export const WebhookHookFormComponent = {
    template: require('./webhook-hook-form.component.html'),
    bindings: {
        hook: '<'
    }
};